import { render, staticRenderFns } from "./TruckDetails.vue?vue&type=template&id=9f874ec8&"
import script from "./TruckDetails.vue?vue&type=script&lang=js&"
export * from "./TruckDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports